import styled from 'styled-components';
import colors from '../../../../../assets/colors';

const Content = styled.div`
  padding: 30px;

  .add-btn {
    background: none;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.9rem;
    color: ${colors.primary};
    padding: 5px;
    cursor: pointer;

    .fa { margin-right: 8px; margin-bottom: -2px; };
    :hover { opacity: .9; }
  }

  .delete-btn {
    height: 40px;
    background: none;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.9rem;
    color: ${colors.red};
    padding: 5px;
    cursor: pointer;

    .fa { margin-right: 8px; margin-bottom: -2px; };
    :hover { opacity: .9; }
  }

  @media screen and (max-width: 767px) {
    .desc-input { margin-bottom: 0px; }
    .delete-btn { margin-bottom: 30px; }
  }
`;

export default Content;
